<template>
  <block component-name="block-form-signup">
    <!-- RESUME -->
    <div
      v-if="
        /(private|professional)-edit/.test($attrs.config.variant) && showResume
      "
      key="resume"
      class="flex flex-col items-start gap-3xl"
      ref="tpl_resume"
    >
      <header class="flex flex-col gap-2xl w-full">
        <btn-pill
          :title="$t.labels.edit_info"
          icon="arrow-long-right"
          @click="showResume = false"
        />

        <div class="w-full max-w-[570px]">
          <txt-prose
            class="!text-skin-muted !text-body-small w-full"
            :html="$t.texts.unsubscribe_account"
          />
        </div>
      </header>

      <div class="flex flex-col w-full desktop:flex-row gap-4xl">
        <div
          class="flex flex-col items-stretch w-full gap-y-2xl desktop:w-9/12"
        >
          <div class="grid w-full grid-cols-12 gap-x-2xl gap-y-md">
            <div
              class="flex flex-col w-full col-span-6 tablet:col-span-4 gap-2xs"
            >
              <wrapper-reveal reveal="fade-from-right">
                <div class="text-overline" v-html="$t.labels.name"></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom">
                <div class="text-body" v-html="userStore.fullName"></div>
              </wrapper-reveal>
            </div>

            <div
              class="flex flex-col w-full col-span-6 tablet:col-span-4 gap-2xs"
            >
              <wrapper-reveal reveal="fade-from-right">
                <div class="text-overline" v-html="$t.labels.email"></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom">
                <div class="text-body" v-html="userStore.user.email"></div>
              </wrapper-reveal>
            </div>

            <div
              v-if="userStore.user.title"
              class="flex flex-col w-full col-span-6 tablet:col-span-4 gap-2xs"
            >
              <wrapper-reveal reveal="fade-from-right">
                <div class="text-overline" v-html="$t.labels.job_title"></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom">
                <div class="text-body" v-html="userStore.user.title"></div>
              </wrapper-reveal>
            </div>

            <div
              v-if="userStore.user.company"
              class="flex flex-col w-full col-span-6 tablet:col-span-4 gap-2xs"
            >
              <wrapper-reveal reveal="fade-from-right">
                <div class="text-overline" v-html="$t.labels.company"></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom">
                <div class="text-body" v-html="userStore.user.company"></div>
              </wrapper-reveal>
            </div>

            <div
              class="flex flex-col w-full col-span-6 tablet:col-span-4 gap-2xs"
            >
              <wrapper-reveal reveal="fade-from-right">
                <div class="text-overline" v-html="$t.labels.country"></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom">
                <div
                  class="text-body"
                  v-html="userStore.user.country_code"
                ></div>
              </wrapper-reveal>
            </div>

            <div
              v-if="
                userStore.user.country_code === 'IT' &&
                userStore.user.state_code
              "
              class="flex flex-col w-full col-span-6 tablet:col-span-4 gap-2xs"
            >
              <wrapper-reveal reveal="fade-from-right">
                <div class="text-overline" v-html="$t.labels.province"></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom">
                <div class="text-body" v-html="userStore.user.state_code"></div>
              </wrapper-reveal>
            </div>

            <div
              v-else-if="
                userStore.user.country_code === 'US' &&
                userStore.user.state_code
              "
              class="flex flex-col w-full col-span-6 tablet:col-span-4 gap-2xs"
            >
              <wrapper-reveal reveal="fade-from-right">
                <div class="text-overline" v-html="$t.labels.state"></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom">
                <div class="text-body" v-html="userStore.user.state_code"></div>
              </wrapper-reveal>
            </div>

            <div
              v-if="userStore.user.city"
              class="flex flex-col w-full col-span-6 tablet:col-span-4 gap-2xs"
            >
              <wrapper-reveal reveal="fade-from-right">
                <div class="text-overline" v-html="$t.labels.city"></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom">
                <div class="text-body" v-html="userStore.user.city"></div>
              </wrapper-reveal>
            </div>

            <div
              v-if="userStore.user.zip"
              class="flex flex-col w-full col-span-6 tablet:col-span-4 gap-2xs"
            >
              <wrapper-reveal reveal="fade-from-right">
                <div class="text-overline" v-html="$t.labels.zip"></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom">
                <div class="text-body" v-html="userStore.user.zip"></div>
              </wrapper-reveal>
            </div>
          </div>

          <footer class="grid w-full grid-cols-12 gap-x-2xl gap-y-md">
            <div
              class="flex flex-col w-full col-span-6 tablet:col-span-4 gap-2xs"
            >
              <wrapper-reveal reveal="fade-from-right">
                <div
                  class="text-overline"
                  v-html="$t.labels.privacy_authorization"
                ></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom">
                <div
                  class="text-body"
                  v-html="
                    userStore.user.privacy == true
                      ? $t.labels.authorized
                      : $t.labels.not_authorized
                  "
                ></div>
              </wrapper-reveal>
            </div>

            <div
              class="flex flex-col w-full col-span-6 tablet:col-span-4 gap-2xs"
            >
              <wrapper-reveal reveal="fade-from-right">
                <div
                  class="text-overline"
                  v-html="$t.labels.marketing_authorization"
                ></div>
              </wrapper-reveal>

              <wrapper-reveal reveal="fade-from-bottom">
                <div
                  class="text-body"
                  v-html="
                    userStore.user.marketing == true
                      ? $t.labels.authorized
                      : $t.labels.not_authorized
                  "
                ></div>
              </wrapper-reveal>
            </div>
          </footer>
        </div>
      </div>
    </div>
    <!-- end RESUME -->

    <!-- FORM -->
    <div v-else key="form" class="grid w-full grid-cols-12 gap-x-ui gap-y-3xl">
      <section class="col-span-full w-full laptop:col-start-1 laptop:col-end-7">
        <div
          class="sticky left-0 flex flex-col items-stretch w-full top-30 laptop:top-40 gap-lg"
        >
          <txt-heading
            size="regular"
            :title="$attrs.data.body.heading.title"
            :text="$attrs.data.body.heading.text"
            class="w-full"
          />

          <div
            v-if="$attrs.data.body.help.text || $attrs.data.body.help.button"
            class="flex items-baseline gap-1"
          >
            <div
              class="text-button text-skin-muted"
              v-html="$attrs.data.body.help.text"
            ></div>

            <btn-nav
              class="text-skin-muted"
              v-if="$attrs.data.body.help.button"
              :title="$attrs.data.body.help.button.title"
              :action="$attrs.data.body.help.button.action"
            />
          </div>
        </div>
      </section>

      <section
        class="col-span-full w-full laptop:col-start-8 laptop:col-end-13"
      >
        <form-signup
          :variant="$attrs.config.variant"
          class="w-full"
          @discard="showResume = true"
          @on-success="
            /(private|professional)-edit/.test($attrs.config.variant)
              ? (showResume = true)
              : undefined
          "
        />
      </section>
    </div>
    <!-- end FORM -->
  </block>
</template>

<script setup>
import { useUserStore } from "@/stores/user";
const userStore = useUserStore();
const showResume = ref(true);
const tpl_resume = templateRef("tpl_resume");
const nuxtApp = useNuxtApp();

watch(showResume, (value) => {
  /* gsap.to(window, {
    onComplete: () => {
      ScrollTrigger.refresh();
    },
    duration: 0.8,
    scrollTo: { y: 0 },
  }); */
  nuxtApp.$lenis.scrollTo(0, {
    force: true,
    lock: true,
    duration: 0.8,
    easing: gsap.parseEase("power2.out"),
    onComplete: () => {
      ScrollTrigger.refresh(true);
    },
  });
});
</script>
